module.exports = __webpack_public_path__ + "static/img/aqzs25.395acbdf.jpg";